import request from '@/utils/request'


// 查询医生内容发布激励活动信息列表
export function listActivity(query) {
  return request({
    url: '/videoreward/activity/list',
    method: 'get',
    params: query
  })
}

// 查询医生内容发布激励活动信息分页
export function pageActivity(query) {
  return request({
    url: '/videoreward/activity/page',
    method: 'get',
    params: query
  })
}

// 查询医生内容发布激励活动信息详细
export function getActivity(data) {
  return request({
    url: '/videoreward/activity/detail',
    method: 'get',
    params: data
  })
}

// 新增医生内容发布激励活动信息
export function addActivity(data) {
  return request({
    url: '/videoreward/activity/add',
    method: 'post',
    data: data
  })
}

// 修改医生内容发布激励活动信息
export function updateActivity(data) {
  return request({
    url: '/videoreward/activity/edit',
    method: 'post',
    data: data
  })
}

// 删除医生内容发布激励活动信息
export function delActivity(data) {
  return request({
    url: '/videoreward/activity/delete',
    method: 'post',
    data: data
  })
}
